import { Center } from '@chakra-ui/react'
import React from 'react'
import { Spinner } from '@chakra-ui/react';

interface ILoader {
    loading: boolean;
}

export default function Loader(props: ILoader) {
    return (
        <>
            {props.loading && <Center><Spinner /></Center>}
        </>
    )
}
